export const base = {
    background: "red",
    color: "white",
    iconbutton: {
        color: "white"
    }
}